export default __webpack_public_path__ + "static/Lato-Regular-79164ee524feb6583a945d26a0ed9feb.ttf";